'use client'
import Filter from '@/components/filter/NewFilter'
import Link from '@/components/router/Link'
import { useSearchParams } from 'next/navigation'
import { ComponentType } from 'react'
import { useCreateFilterPathFunc } from 'shared/UseCreateFilterPathFunc'
import { isTabletScreen } from 'shared/domHelpers'
import { Facet } from 'types'

const AbcFilter: ComponentType<{ basePath: string; facet: Facet }> = ({
  basePath,
  facet
}) => {
  const isTablet = isTabletScreen()
  const searchParams = useSearchParams()
  const queryPart = new URLSearchParams(searchParams ?? [])
  const isActivePath = (letter: string) => queryPart.get('letter') === letter
  const getLetterRoute = useCreateFilterPathFunc(basePath, 'letter')

  return (
    <>
      {isTablet ? (
        <Filter
          removable={facet.removable}
          title="ABC"
          links={facet.values.map(({ id, name }) => ({
            text: name,
            selected: false,
            addFilterPath: getLetterRoute.addFilter(id),
            removeFilterPath: getLetterRoute.removeFilter(),
            activeEqualsToFunc: () => isActivePath(id)
          }))}
        />
      ) : (
        <>
          <div className="text-xs opacity-50 mt-4 pt-4 pb-2 border-gray-300">
            alphabetischer Filter
          </div>
          <div className="abc-filter flex justify-between">
            {facet.values.map(({ id, name }) => {
              return (
                <Link
                  key={id}
                  activeClassName="active"
                  href={
                    isActivePath(id)
                      ? getLetterRoute.removeFilter()
                      : getLetterRoute.addFilter(id)
                  }
                  activeEqualsToFunc={() => isActivePath(id)}
                >
                  {name}
                </Link>
              )
            })}
          </div>
        </>
      )}
    </>
  )
}

export default AbcFilter
